module.exports = __webpack_public_path__ + "images/forbes-colored-22586e.svg";